/** The boot loader inlined in `index.html` (Signal board 17) exposes this on `window`. */
interface BootLoaderController {
  hide: () => void;
  fail: () => void;
}

declare global {
  interface Window {
    bpBootLoader?: BootLoaderController;
  }
}

/**
 * Hands the screen from the `index.html` boot loader to the app. The loader keeps itself on
 * screen long enough not to flash and leaves with its own exit. Safe to call more than once
 * and when the loader is gone (tests, webviews).
 */
export function hideBootLoader() {
  window.bpBootLoader?.hide();
}
